// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditAddress {
    width: 100%;
}

.editAddressContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
}

.editAddressCard {
    width: 90%;
    background-color: #0E1B1B;
    border: 1px solid #1E2D2D;
    border-radius: 14px;
    padding: 24px 28px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    box-sizing: border-box;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}

@media (max-width: 768px) {
    .editAddressCard {
        width: 95%;
        padding: 18px 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/EditAddress/EditAddress.css"],"names":[],"mappings":"AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI;QACI,UAAU;QACV,kBAAkB;IACtB;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\");\n\n.EditAddress {\n    width: 100%;\n}\n\n.editAddressContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n}\n\n.editAddressCard {\n    width: 90%;\n    background-color: #0E1B1B;\n    border: 1px solid #1E2D2D;\n    border-radius: 14px;\n    padding: 24px 28px;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    box-sizing: border-box;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\n}\n\n@media (max-width: 768px) {\n    .editAddressCard {\n        width: 95%;\n        padding: 18px 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
